import React from 'react'
import PropTypes from 'prop-types'
import { prop, propOr } from 'ramda'
import { useDispatch } from 'react-redux'
import { withRouter } from 'react-router'
import { useSelector } from 'hooks/redux'
import ReduxNavigator from 'components/Navigator/ReduxNavigator'
import { startSearch } from 'actions/search'
import { navigatorIsFullscreen } from 'actions/navigator'
import { getVehicleSubType } from 'selectors/truck'
import {
  FEATURE,
  ADD_REMOVE_FEATURE_COLLECTIONS,
  ADD_REMOVE_FEATURES,
  ADD_REF_PARAMETERS_WORKFLOW,
  APPLY_FAST_FEATURES,
} from 'utils/constants'
import FeatureCollections from 'components/vehicles/Summary/ChecPlusVehicleSummary/AddRemoveVehicleFeatures/FeatureCollections'
import AddRemoveVehicleFeaturesContainer from 'components/vehicles/Summary/ChecPlusVehicleSummary/AddRemoveVehicleFeatures/AddRemoveVehicleFeaturesContainer'
import AddReferenceParametersWorkflow from 'components/AddReferenceParametersWorkflow'

const VehicleNavigator = ({ location }) => {
  const dispatch = useDispatch()
  const pathname = propOr('', 'pathname', location)
  const serialNumber = prop(2, pathname.split('/'))
  const vehicleSubType = useSelector(getVehicleSubType, { serialNumber })

  dispatch(navigatorIsFullscreen(true))
  dispatch(
    startSearch(FEATURE, 'features/search', {
      serial: serialNumber,
      filterConflicts: true,
      vehicleSubType,
    })
  )

  return (
    <ReduxNavigator
      render={(renderProps) => {
        const { id } = renderProps

        if (id === ADD_REF_PARAMETERS_WORKFLOW) {
          return <AddReferenceParametersWorkflow serialNumber={serialNumber} />
        }

        if (id === ADD_REMOVE_FEATURES) {
          return (
            <AddRemoveVehicleFeaturesContainer
              {...renderProps}
              serialNumber={serialNumber}
              // use to know if on summary, ecu, s&g
              location={location}
            />
          )
        }

        if (id === APPLY_FAST_FEATURES) {
          return (
            <AddRemoveVehicleFeaturesContainer
              {...renderProps}
              serialNumber={serialNumber}
              location={location}
              showFastFeatureFilters
            />
          )
        }

        if (id === ADD_REMOVE_FEATURE_COLLECTIONS) {
          return (
            <FeatureCollections {...renderProps} serialNumber={serialNumber} />
          )
        }

        return null
      }}
    />
  )
}

VehicleNavigator.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.object,
}

export default withRouter(VehicleNavigator)
